// ══════════════════════════════════════════════
//  Breadcoins Recipe — Interactive Functions
//  Load via section-blog-post.liquid
// ══════════════════════════════════════════════

document.addEventListener('DOMContentLoaded', function () {

  // ── state ──
  var _bciState = { unit: 'metric', scale: 1 };

  // ── print ──
  window.bciPrint = function () {
    window.focus();
    window.print();
  };

  // ── smooth scroll + active tab ──
  window.bciScrollTo = function (id, btn) {
    var target = document.getElementById(id);
    if (!target) return false;
    var wrap = document.querySelector('.bci .tab-nav-wrap');
    var navH = wrap ? wrap.offsetHeight : 60;
    var top = target.getBoundingClientRect().top + window.pageYOffset - navH - 8;
    window.scrollTo({ top: top, behavior: 'smooth' });
    document.querySelectorAll('.bci .tab-btn').forEach(function (b) {
      b.classList.remove('active');
    });
    if (btn) btn.classList.add('active');
    return false;
  };

  // ── unit toggle ──
  window.bciSetUnit = function (mode, btn) {
    _bciState.unit = mode;
    btn.closest('.unit-toggle').querySelectorAll('.unit-btn').forEach(function (b) {
      b.classList.remove('active');
    });
    btn.classList.add('active');
    _bciRender();
  };

  // ── scale presets ──
  window.bciSetScale = function (factor, btn) {
    _bciState.scale = factor;
    btn.closest('.scale-ctrl').querySelectorAll('.scale-preset').forEach(function (b) {
      b.classList.remove('active');
    });
    btn.classList.add('active');
    var inp = document.getElementById('bci-scale-input');
    if (inp) inp.value = factor;
    _bciRender();
  };

  // ── custom scale input ──
  window.bciSetScaleCustom = function (input) {
    var val = parseFloat(input.value);
    if (isNaN(val) || val <= 0) return;
    _bciState.scale = val;
    var presets = [0.25, 0.5, 1, 1.5, 2, 3];
    input.closest('.scale-ctrl').querySelectorAll('.scale-preset').forEach(function (b, i) {
      b.classList.toggle('active', presets[i] === val);
    });
    _bciRender();
  };

  // ── render ingredient table ──
  function _bciRender() {
    var isMetric = (_bciState.unit === 'metric');
    var scale = _bciState.scale;
    var table = document.querySelector('.bci .ingr-table');
    if (!table) return;

    var qHead = table.querySelector('thead th:nth-child(2)');
    var uHead = table.querySelector('thead th:nth-child(3)');
    if (qHead) qHead.textContent = isMetric ? 'Grams' : 'Amount';
    if (uHead) uHead.textContent = isMetric ? '' : 'Unit';

    table.querySelectorAll('tbody tr').forEach(function (row) {
      var q = row.querySelector('.qty');
      var u = row.querySelector('.unit-col');
      if (!q) return;
      if (isMetric) {
        q.textContent = _bciFmt(parseFloat(q.dataset.g) * scale, 'g');
        if (u) u.textContent = '';
      } else {
        var base = parseFloat(q.dataset.impVal || q.dataset.g);
        var unt = q.dataset.impUnit || '';
        q.textContent = _bciFmt(base * scale, unt);
        if (u) u.textContent = unt;
      }
    });

    var batchEl = document.getElementById('bci-batch');
    if (batchEl) {
      var old = batchEl.querySelector('.batch-scale-note');
      if (old) old.remove();
      if (scale !== 1) {
        var note = document.createElement('span');
        note.className = 'batch-scale-note';
        note.textContent = ' \u00d7' + (scale % 1 === 0 ? scale : scale.toFixed(2)) + ' batch';
        batchEl.appendChild(note);
      }
    }
  }

  function _bciFmt(val, unit) {
    if (val === 0) return '0';
    if (['tsp', 'tbsp'].includes(unit)) return _bciFrac(Math.round(val * 8) / 8);
    if (val >= 100) return Math.round(val).toLocaleString();
    if (val >= 10) return (Math.round(val * 10) / 10).toLocaleString();
    return (Math.round(val * 100) / 100).toLocaleString();
  }

  function _bciFrac(n) {
    var whole = Math.floor(n);
    var frac = Math.round((n - whole) * 8);
    var map = { 0: '', 1: '⅛', 2: '¼', 3: '⅜', 4: '½', 5: '⅝', 6: '¾', 7: '⅞' };
    var f = map[frac] || '';
    if (whole === 0) return f || '0';
    return whole + (f ? '\u00a0' + f : '');
  }

  // ── wire up buttons (since onclick attrs may be stripped by Shopify) ──
  document.querySelectorAll('.bci .unit-btn').forEach(function (btn, i) {
    btn.addEventListener('click', function () {
      bciSetUnit(i === 0 ? 'metric' : 'imperial', btn);
    });
  });

  document.querySelectorAll('.bci .scale-preset').forEach(function (btn, i) {
    var factors = [0.25, 0.5, 1, 1.5, 2, 3];
    btn.addEventListener('click', function () {
      bciSetScale(factors[i], btn);
    });
  });

  var scaleInput = document.getElementById('bci-scale-input');
  if (scaleInput) {
    scaleInput.addEventListener('input', function () {
      bciSetScaleCustom(scaleInput);
    });
  }

  var printBtn = document.querySelector('.bci .bci-print-btn');
  if (printBtn) {
    printBtn.addEventListener('click', function () {
      bciPrint();
    });
  }

  document.querySelectorAll('.bci .tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var href = btn.getAttribute('href');
      if (href) {
        var id = href.replace('#', '');
        bciScrollTo(id, btn);
      }
    });
  });

  // ── scrollspy ──
  var sections = ['bci-why', 'bci-ingredients', 'bci-prep', 'bci-combine', 'bci-cook', 'bci-storing', 'bci-photos'];
  window.addEventListener('scroll', function () {
    var wrap = document.querySelector('.bci .tab-nav-wrap');
    var navH = wrap ? wrap.offsetHeight : 60;
    var active = sections[0];
    sections.forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.getBoundingClientRect().top <= navH + 20) active = id;
    });
    document.querySelectorAll('.bci .tab-btn').forEach(function (btn, i) {
      btn.classList.toggle('active', sections[i] === active);
    });
  }, { passive: true });

}); // end DOMContentLoaded